export default __webpack_public_path__ + "static/media/tracking.a672bd89.png";